import { defineComponent } from "@vue/composition-api";
import { useI18n } from "vue-i18n-composable";
import ScrollableContainer from "@Shared/components/general/scrollable-container.vue";
import { CALCULATOR_PATHS } from "@Shared/@Utils/constants";
export default defineComponent({
  name: "MortgageCalculatorsTabs",
  components: {
    ScrollableContainer
  },
  setup() {
    const {
      t
    } = useI18n();
    const pages = [{
      route: {
        name: CALCULATOR_PATHS.maximumMortgageCalcs
      },
      label: t("financial-tools.maximumMortgage")
    }, {
      route: {
        name: CALCULATOR_PATHS.mortgageIsolatorCalcs
      },
      label: t("financial-tools.mortgageIsolator")
    }, {
      route: {
        name: CALCULATOR_PATHS.paymentAnalyzerCalcs
      },
      label: t("financial-tools.payment_analyzer")
    }, {
      route: {
        name: CALCULATOR_PATHS.prepaymentAnalyzerCalcs
      },
      label: t("financial-tools.prepayment_analyzer")
    }, {
      route: {
        name: CALCULATOR_PATHS.scenarioBuilderCalcs
      },
      label: t("financial-tools.scenarioBuilder")
    }, {
      route: {
        name: CALCULATOR_PATHS.minimumIncomeCalcs
      },
      label: t("financial-tools.minimumIncomeRequired")
    }, {
      route: {
        name: CALCULATOR_PATHS.rentBuyAnalyzerCalcs
      },
      label: t("financial-tools.rentBuyAnalyzer")
    }, {
      route: {
        name: CALCULATOR_PATHS.mortgageAnalyzerCalcs
      },
      label: t("financial-tools.mortgage_analyzer")
    }, {
      route: {
        name: CALCULATOR_PATHS.amortizationScheduleCalcs
      },
      label: t("financial-tools.amortizationSchedule")
    }];
    return {
      pages
    };
  }
});